import _get from 'lodash/get';

import { objectToCamelCase } from '../../../../libs/format';

export function selectHtmlElements(state) {
  return Object.values(objectToCamelCase(_get(state, 'htmlElements.entities')));
}
